import { inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthCookie } from '../../models/auth-cookie';

@Injectable({
  providedIn: 'root',
})
export class AuthCookieService {
  private cookieService = inject(CookieService);
  private expirationDateTime: any;

  private readonly AUTH_COOKIE_TITLE = 'BoltTestHubAuthentication';
  private readonly PATH = '/';
  private readonly SECURE = true;
  private readonly PARTITIONED = false;
  private readonly SAME_SITE = 'Strict';

  constructor() {}

  get accessToken(): string {
    return this.cookie.accessToken || '';
  }

  set accessToken(token: string) {
    const cookieCopy = this.cookie;
    cookieCopy.accessToken = token;
    this.cookie = cookieCopy;
  }

  get expiration(): Date {
    return this.expirationDateTime;
  }

  set expiration(expiration: Date) {
    this.expirationDateTime = expiration;
  }

  buildCookie(accessToken: string, expiresOn: Date) {
    this.expirationDateTime = expiresOn;
    this.accessToken = accessToken;
  }

  deleteCookie(): void {
    this.cookieService.delete(
      this.AUTH_COOKIE_TITLE,
      this.PATH,
      undefined,
      this.SECURE,
      this.SAME_SITE,
    );
  }

  private get cookie(): AuthCookie {
    const cookie = this.cookieService.get(this.AUTH_COOKIE_TITLE);
    return cookie ? { ...JSON.parse(cookie) } : ({} as AuthCookie);
  }

  private set cookie(cookie: AuthCookie) {
    this.cookieService.set(this.AUTH_COOKIE_TITLE, JSON.stringify(cookie), {
      path: this.PATH,
      expires: this.expiration,
      secure: this.SECURE,
      partitioned: this.PARTITIONED,
      sameSite: this.SAME_SITE,
    });
  }
}
